import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Navbar from './ui/Navbar/Navbar';
import Header from './pages/Header/Header';
import Courses from './pages/Courses/Courses';
import Teachers from './pages/Teachers/Teachers';
import History from './pages/History/History';
import Biography from './pages/Biography/Biography';
import Store from './pages/Store/Store';
import Space from './pages/Space/Space';
import Footer from './ui/Footer/Footer';
import WhatsAppButton from './common/WhatsAppButton/WhatsAppButton';

function AppPreLoad() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Header />
        <Courses />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default AppPreLoad;